<template>
  <myDialog :isDialog="isDialog" title="标签选择" :width="'50%'" @handleClose="save">
    <template slot="content">
      <div class="selectTagContent">
        <!-- 已选标签 -->
        <div class="selectTag" v-if="!isView">
          <div class="tagTitle">
            <div class="title">已选标签</div>
            <div class="line"></div>
          </div>
          <div class="tagContent">
            <div  v-for="(item,index) in selectTagList" :key="index" class="tag" :style="{backgroundColor: item.color}">
              <i class="el-icon-error" @click="handleTagClose(item,index)"></i>
              <div class="tagLeft" :style="{color: item.color}">
                <img src="@/assets/images/sys/bqgl/tag-icon.png" alt="">
              </div>
              <div class="tagRight">{{ item.bqLabel }}</div>
            </div>
          </div>
        </div>
        <!-- 待选标签 -->
        <div class="waitTag">
          <div class="tagTitle" v-if="!isView">
            <div class="title">待选标签</div>
            <div class="line"></div>
          </div>
          <div style="overflow: auto;" :style="isView?'height:55vh;':'height:33vh;'">
            <itemTag :treeData="treeData" :defaultExpandedKeys="defaultExpandedKeys" :isView="isView" @nodeClick="nodeClick" @tagClick="tagClick"></itemTag>
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <!-- <div class="cancelBtn" @click="$emit('handleClose')">关闭</div>
        <div class="fillBtn ml-2" @click="save">保存</div> -->
      <div class="cancelBtn" v-if="isView" @click="save">关闭</div>
      <div class="cancelBtn" v-else @click="save">确定</div>
    </template>
  </myDialog>
</template>

<script>
import itemTag from './components/itemTag.vue'
import {bqlxQueryBqLxbByCode} from "@/api/bqgl.js";
export default {
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    bqLxCode:{
      type:[String,Number],
      default:''
    },
    isView:{
      type:Boolean,
      default:false
    },
    tagData:{
      type:Array,
      default:()=>[]
    },
  },
  components:{
    itemTag,
  },
  data() {
    return {
      defaultExpandedKeys:[],// 默认展开的节点
      selectTagList: [],//已选标签
      selectNodeList: [],//已选标签所属节点
      waitTag:[],//待选标签
      treeData:[
        // { id: 1, name: '一级1', tagList:[{id:1,name:'IT技术宅'},{id:2,name:'外卖达人'}], },
        // {
        //   id: 2,
        //   name: '一级2',
        //   tagList:[{id:3,name:'标签一'},{id:4,name:'标签二'}],
        //   children: [
        //     { id: 3, name: '二级2-1',tagList:[{id:5,name:'标签一'},{id:6,name:'标签二'},{id:7,name:'标签三'}], },
        //     { id: 4, name: '二级2-2' }
        //   ]
        // },
        // {
        //   id: 5,
        //   name: '一级3',
        //   children: [
        //     {
        //       id: 6,
        //       name: '二级3-1',
        //       children: [
        //         { id: 7, name: '三级3-1-1' },
        //         { id: 8, name: '三级3-1-2' }
        //       ]
        //     },
        //     { id: 9, name: '二级3-2' },
        //     { id: 10, name: '二级3-3' }
        //   ]
        // }
      ]
    }
  },
  mounted() {
    this.$nextTick(()=>{
      // 获取标签tree
      this.getTree()
    })
  },
  methods: {
    save(){
      if(this.isView){//查看
        this.$emit('handleClose')
      }else{//修改
        this.$emit('saveSelectTage',this.selectTagList)
      }
    },
    // 获取标签tree
    getTree(){
      this.selectTagList=[];
      bqlxQueryBqLxbByCode({code:this.bqLxCode}).then(res=>{
        if(res && res.code==200 && res.data){
          if(Array.isArray(res.data)){
            this.treeData=res.data;
          }else{
            this.treeData=[res.data];
          }
          // console.log(res.data);
          // 给标签加下标
          this.addIndexToTagList(this.treeData);
          // let selectTagList = JSON.parse(JSON.stringify(this.selectTagList));
          // this.$emit('selectTagListChange',selectTagList);
          this.$emit('selectTagListChange',this.selectTagList);
        }
      })
    },
    // 标签关闭
    handleTagClose(item,index) {
      // console.log(item,'item');
      this.selectTagList.splice(index, 1);
      this.selectNodeList[index].bqXxbs.splice(item.idx,0,item)
      this.selectNodeList.splice(index,1)

    },
    // 标签点击
    tagClick(e){
      this.selectTagList.push(e[0]);
      this.selectNodeList.push(e[1]);
    },
    // 节点点击
    nodeClick(val) {
      // console.log(val)
    },
    addIndexToTagList(treeData) {
      const colors = ['#5FABF8', '#F29D45', '#64CCD4','#84D389','#83E4DF'];
      treeData.forEach(node => {
        // 展开一级节点
        if(node.parentId==='0'){
          this.defaultExpandedKeys.push(node.id);
        }
        if (node.bqXxbs) {
          let colorIndex = 0;
          node.bqXxbs = node.bqXxbs.filter((tag, idx) => {
            tag.idx = idx;
            tag.color = colors[colorIndex];


            if (this.tagData && this.tagData.includes(tag.bqValue)) {
              // 如果选中的标签里已经有了tag和node，就不保存了
              if(!this.selectTagList.some(item => item.bqValue == tag.bqValue)){
                this.selectTagList.push(tag);
              }
              if(!this.selectNodeList.some(item => item.bqValue == tag.bqValue)){
                this.selectNodeList.push(node);
              }

              colorIndex = (colorIndex + 1) % colors.length; // 循环更新颜色索引
              return false; // 过滤掉需要删除的标签
            }
            colorIndex = (colorIndex + 1) % colors.length; // 循环更新颜色索引
            return true; // 保留不需要删除的标签
          });
        }
        if (node.children) {
          this.addIndexToTagList(node.children);
        }
      });
    },
    		

		


  },
}
</script>

<style lang="scss" scoped>
@import url('~@/views/sys/bqgl/style/tag.scss');
.selectTagContent{
  width: 100%;
  background: #ffffff;
  .tagTitle{
    display: flex;
    align-items: center;
    width: 100%;
    height: 34px;
    background: #f3f6fd;
    padding-right: 24px;
    .title{
      width: 90px;
      padding-left: 8px;
      border-left: 2.5px solid #0c7bf2;;
      color: #0c7bf2;
      font-weight: bold;
      font-size: 14px;
      background: #f3f6fd;
    }
    .line{
      width: 100%;
      height: 1px;
      background: #d1d5dc;
    }
  }
  .tagContent{
    padding: 16px 24px;
    min-height: 120px;
    max-height: 120px;
    border-radius: 5px;
    border: 1px dashed #0c7bf21a;
    background: #fcfcfc;
    overflow: auto;

    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }
  .selectTag{
    margin-bottom: 16px;
    
  }
}
.btn{
  cursor: pointer;
  width: 120px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  border: 1px solid #dddddd;
}

</style>
